import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import { UserService } from "../../services/userService";

import logger from "../../core/utils/logger";

//Async thunk for getting users in organisation
export const getUsersInOrganisation=createAsyncThunk(
    'user/getUsersInOrganisation',
    async(_, {rejectWithValue})=>{
        try{
            const response=await UserService.getUsersInOrganisationRequest();
            logger.log("Users in organisation response:", response);
            return response;
        }catch(error){
            return rejectWithValue(error.response?.data || 'Error getting users in organisation');
        }
    }
);
//Async thunk for setting user information
export const setUserInformation=createAsyncThunk(
    'user/setUserInformation',
    async(userData, {rejectWithValue})=>{
        try{
            const response=await UserService.setUserInformation(userData);
            logger.log("User information update response:", response);
            return response;
        }catch(error){
            return rejectWithValue(error.response?.data || 'Error updating user information');
        }
    }
);
//Async thunk for deleting user
export const deleteUser=createAsyncThunk(
    'user/deleteUser',
    async(userId, {rejectWithValue})=>{
        try{
            await UserService.deleteUser(userId);
            logger.log("User deleted successfully:", userId);
            return userId;
        }catch(error){
            return rejectWithValue(error.response?.data || 'Error deleting user');
        }
    }
);
const initialState={
    users:{
        loading:false,
        error:null,
        users:[]
    }
};
const userSlice=createSlice({
    name:'userData',
    initialState,
    reducers:{
        clearState:(state)=>{
            state.users.loading=false;
            state.users.error=null;
            state.users.users=[];
        }
    },
    extraReducers:(builder)=>{
        builder.addCase(getUsersInOrganisation.pending,(state)=>{
            state.users.loading=true;
            state.users.error=null;
            state.users.users=[];
        });
        builder.addCase(getUsersInOrganisation.fulfilled,(state,action)=>{
            state.users.loading=false;
            state.users.error=null;
            state.users.users=action.payload;
        });
        builder.addCase(getUsersInOrganisation.rejected,(state,action)=>{
            state.users.loading=false;
            state.users.error=action.payload;
            state.users.users=[];
        });
        builder.addCase(setUserInformation.pending,(state)=>{
            state.users.loading=true;
            state.users.error=null;
        });
        builder.addCase(setUserInformation.fulfilled,(state,action)=>{
            state.users.loading=false;
            state.users.error=null;
            const updatedUser=action.payload;
            const index=state.users.users.findIndex(user=>user.id===updatedUser.id);
            if(index!==-1){
                state.users.users[index]=updatedUser;
            }
        });
        builder.addCase(setUserInformation.rejected,(state,action)=>{
            state.users.loading=false;
            state.users.error=action.payload;
        });
        builder.addCase(deleteUser.pending,(state)=>{
            state.users.loading=true;
            state.users.error=null;
        });
        builder.addCase(deleteUser.fulfilled,(state,action)=>{
            state.users.loading=false;
            state.users.error=null;
            const deletedUserId=action.payload;
            state.users.users=state.users.users.filter(user=>user.id!==deletedUserId);
        });
        builder.addCase(deleteUser.rejected,(state,action)=>{
            state.users.loading=false;
            state.users.error=action.payload;
        });


    },
});
export const {clearState}=userSlice.actions;
export default userSlice.reducer;